/* global fbq */

import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import StepsIcon from "./StepsIcon.jsx";
import { Formik } from "formik";
import * as Yup from "yup";
import BasicDetails from "./BasicDetails";
import SkillDetails from "./SkillDetails";
import Achievements from "./Acheivements.jsx";
import MediaShowcase from "./MediaShowcase.jsx";
import axios from "axios";
import { ENV, path } from "../../../path.js";
import ReactGA from "react-ga4";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import SignUpModal from "../SignUpModal.js";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { setJudgeDataId } from "../../../store/asyncMethods/AuthMethods.js";
import { skillData, subCatData } from "./skillRawData.js";
import { EventTypes, trackEvent } from "../../../Utils/Analytics.js";
import { getPlaystoreLinks } from "../../../Utils/attribution.js";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  profilePicture: "",
  contactNumber: "",
  upi: "",
  yearsOfExp: "",
  skill: null,
  subCat: "",
  achievements: "",
  WorkLinks: [],
  Certifications: [],
  performance: [],
  intro: null,
  cameraMicAvailable: true,
  allowPromotion: true,
  subscribeUpdates: true,
};

function ApplyAsJudge() {
  const [currentStep, setCurrentStep] = useState(0);
  const [filledStatus, setFilledStatus] = useState(0);
  const [isEnglish, setIsEnglish] = useState(true);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const { user } = useSelector((state) => state.AuthReducer);
  const [loading, setLoading] = useState(null);
  const [judgeProfile, setJudgeProfile] = useState(null);

  const formikRef = useRef();
  const dispatch = useDispatch();

  const { intentUrl: androidIntentUrl , playStoreLink } = getPlaystoreLinks();
  const ua = window.navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = ua.includes("Android");
  const playstoreIntentUrl = isAndroid? androidIntentUrl: playStoreLink;

  const loadJudgeProfile = async (judgeId) => {
    try {
      const response = await axios.get(`${path}/getApplicantById/${judgeId}`);
      console.log(response)
      setJudgeProfile(response.data.judge);
    } catch(error) {
      if(error.response.status === 404) {
        dispatch(setJudgeDataId(null));
      } else {
        toast.error("Error loading judge form!")
      }
    } finally {
      setLoading(null);
    }
  }

  useEffect(() => {
    const hash = window.location.hash;

    // Example: "#/contest/67dbee4b1d099920ffb32a76?refId=xxx&openSignUp=true"
    const queryString = hash.split("?")[1];

    const params = new URLSearchParams(queryString);

    const refId = params.get("refId");
    const openSignUp = params.get("openSignUp");

    // Set uniqueId if not already set
    if (!localStorage.getItem("uniqueId")) {
      if (refId) {
        localStorage.setItem("uniqueId", refId);
      } else {
        localStorage.setItem("uniqueId", uuid());
      }
    }

    if (!user?._id && openSignUp === "true") {
      setSignUpModalOpen(true);
    }
  }, []);

  useEffect(() => {
    if (user && formikRef.current) {
      setLoading("loadingJudgeProfile")
      formikRef.current.setValues((prev) => ({
        ...prev,
        firstName: user.firstName || "",
        email: user.email || "",
        ...(user.lastName && { lastName: user.lastName }),
        ...(user.phone && { contactNumber: user.phone }),
        ...(user.paymentDetail && { upi: user.paymentDetail }),
        ...(user.profilePicture && { profilePicture: user.profilePicture })
      }));
      if(user.judgeData) {
        loadJudgeProfile(user.judgeData);
      } else {
        setLoading(null);
      }
    }
  }, [user]);

  let validationSchema = Yup.object().shape({});

  if (currentStep === 0) {
    validationSchema = Yup.object().shape({
      firstName: Yup.string()
        .required("First Name is required")
        .label("First Name"),
      lastName: Yup.string()
        .required("Last Name is required")
        .label("Last Name"),
      profilePicture: Yup.mixed()
        .required("Profile Picture is required")
        .label("Profile Picture"),
      contactNumber: Yup.string()
        .matches(/^[0-9]+$/, "Contact Number must contain only digits")
        .required("Contact Number is required")
        .label("Contact Number"),
      upi: Yup.string()
        .matches(
          /^[\w.\-]+@[a-zA-Z]+$/,
          "UPI ID must be in the format username@bank"
        )
        .required("UPI ID is required")
        .label("UPI"),
      email: Yup.string()
        .email("Enter a valid email address")
        .required("Email is required")
        .label("Email"),
    });
  } else if (currentStep === 1) {
    validationSchema = Yup.object().shape({
      skill: Yup.string().required().label("Skill"),
      subCat: Yup.string().required().label("Skill Sub-Category"),
      yearsOfExp: Yup.number().min(8).required().label("Years of Experience"),
    });
  } else if (currentStep === 2) {
    validationSchema = Yup.object().shape({
      achievements: Yup.string()
        .min(200, "Achievements must be at least 200 characters")
        .max(500, "Achievements can't be more than 500 characters")
        .required("Achievements is required")
        .label("Achievements"),

      WorkLinks: Yup.array()
        // .min(2, "Please provide at least two work links")
        // .test("is-valid-url", "Work Links must be a vaild url", (links) => {
        //   if (!links) {
        //     return false;
        //   }
        //   const urlRegex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
        //   return links.every((link) => urlRegex.test(link));
        // })
        .label("Work Links"),

      Certifications: Yup.array()
        .of(Yup.object())
        .min(2, "Please provide at least two Degree/Certificate")
        .label("Degrees/Certifications"),
    });
  } else if (currentStep === 3) {
    validationSchema = Yup.object().shape({
      performance: Yup.array()
        .of(Yup.mixed())
        .min(3, "Please provide at least 3 performance videos")
        .required("Performance videos are required")
        .label("Performance Videos"),
      intro: Yup.mixed()
        .required("Introduction video is required")
        .label("Introduction Video"),
    });
  }

  const generateFileName = (file, mediaType) => {
    const timestamp = Date.now();
    const ext = mediaType === "image" ? ".jpeg" : ".mp4";

    // Remove existing extension and non-word characters
    const nameWithoutExt = file.name.replace(/\.[^/.]+$/, ""); // strips `.xxx`
    const safeBaseName = nameWithoutExt.replace(/\W+/g, ""); // strips special chars

    return `Box_${timestamp}_${safeBaseName}${ext}`;
  };

  const MAX_SIZE = 50 * 1024 * 1024; // 50MB

  const uploadFileToBox = async (file, type, accessToken, onProgress = () => {}) => {
    if (!file) {
      throw new Error("No file provided");
    }
    if (!accessToken) {
      throw new Error("Access token not provided");
    }

    const fileName = generateFileName(file, type);

    if (file.size < MAX_SIZE) {
      return await directUpload(file, accessToken, fileName, onProgress);
    } else {
      return await chunkedUpload(file, accessToken, fileName, onProgress);
    }
  };

  const directUpload = async (file, accessToken, fileName, onProgress) => {
    const formData = new FormData();
    formData.append("file", file, fileName);
    formData.append("parent_id", "0");

    const response = await axios.post(
      "https://upload.box.com/api/2.0/files/content",
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          onProgress(percent);
        },
      }
    );

    const fileData = response.data.entries[0];

    const { data: urlData } = await axios.post(`${path}/genrate-Url`, {
      id: fileData.id,
      name: fileName,
    });

    return {
      file_id: fileData.id,
      file_url: urlData.file_url,
    };
  };

  const chunkedUpload = async (file, accessToken, fileName, onProgress) => {
    const { data: session } = await axios.post(
      "https://upload.box.com/api/2.0/files/upload_sessions",
      {
        folder_id: "0",
        file_size: file.size,
        file_name: fileName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const { id: sessionId, part_size: partSize } = session;
    let offset = 0;
    const parts = [];
    let shaTotal = CryptoJS.algo.SHA1.create();

    while (offset < file.size) {
      const chunk = file.slice(offset, offset + partSize);
      const chunkBuffer = await chunk.arrayBuffer();
      const wordArray = CryptoJS.lib.WordArray.create(chunkBuffer);
      const sha1Digest = CryptoJS.SHA1(wordArray).toString(CryptoJS.enc.Base64);

      shaTotal.update(wordArray);

      const { data } = await axios.put(
        `https://upload.box.com/api/2.0/files/upload_sessions/${sessionId}`,
        new Blob([chunkBuffer]),
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/octet-stream",
            "Content-Range": `bytes ${offset}-${offset + chunkBuffer.byteLength - 1}/${file.size}`,
            Digest: `sha=${sha1Digest}`,
          },
          onUploadProgress: (e) => {
            const percent = (((offset + e.loaded) / file.size) * 100).toFixed(
              2
            );
            onProgress(percent);
          },
        }
      );

      parts.push(data.part);
      offset += chunkBuffer.byteLength;
    }

    const fullDigest = shaTotal.finalize().toString(CryptoJS.enc.Base64);

    const commitRes = await axios.post(
      `https://upload.box.com/api/2.0/files/upload_sessions/${sessionId}/commit`,
      { parts },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Digest: `sha=${fullDigest}`,
          "Content-Type": "application/json",
        },
      }
    );

    const fileData = commitRes.data.entries[0];

    // Generate file URL (adjust as per your API)
    const { data: urlData } = await axios.post(`${path}/genrate-Url`, {
      id: fileData.id,
      name: fileName,
    });

    return {
      file_id: fileData.id,
      file_url: urlData.file_url,
    };
  };

  const getAccessToken = async () => {
    const { data } = await axios.get(`${path}/getUploadToken`);
    return data.accessToken;
  };

  const handleJudgeSubmit = async (values) => {
    setFilledStatus(currentStep);

    if (currentStep !== 3) {
      setCurrentStep((prev) => prev + 1);

      if(currentStep === 2) { //completed achievements section
        if(ENV === "prod") {
          ReactGA.event("apply_as_judge_achievement", {
            user_id: user?._id || "not loggedIn",
          });
          fbq("trackCustom", "apply_as_judge_achievement", {
            user_id: user?._id || "not loggedIn",
            email: user?.email || "",
          });
          trackEvent(EventTypes.APPLY_AS_JUDGE_ACHIEVEMENT);
        }
      }
      return;
    }

    try {
      setLoading("judgeSubmit");
      setUploadProgress(0);
      const accessToken = await getAccessToken();

      // Collect all files as an array of { label, file }
      console.info("Values:", values);
      const filesToUpload = [];

      if (values.profilePicture instanceof File) {
        filesToUpload.push({
          label: "profilePicture",
          file: values.profilePicture,
          type: "image"
        });
      }
      if (values.intro) {
        filesToUpload.push({ label: "intro", file: values.intro.file, type: "video" });
      }

      (values.performance || []).forEach((item, i) =>
        filesToUpload.push({ label: `performance-${i}`, file: item.file, type: "video" })
      );

      (values.Certifications || []).forEach((item, i) =>
        filesToUpload.push({ label: `certification-${i}`, file: item.file, type: "image" })
      );

      const totalSize = filesToUpload.reduce((sum, f) => sum + f.file.size, 0);
      const uploadedMap = {}; // Track current uploaded bytes for each file

      const updateProgress = () => {
        const uploaded = Object.values(uploadedMap).reduce((a, b) => a + b, 0);
        const percent = Math.min(Math.round((uploaded / totalSize) * 100), 100);
        setUploadProgress(percent);
      };

      const uploadPromises = filesToUpload.map(({ label, file, type }) => {
        return uploadFileToBox(file, type, accessToken, (percent) => {
          uploadedMap[label] = (file.size * percent) / 100;
          updateProgress();
        }).then((result) => ({ label, result }));
      });

      const uploadedResults = await Promise.all(uploadPromises);

      const rawSkill = values.skill
      const formattedSkill = skillData.find(s => s.value === rawSkill)?.label || null;
      
      const rawSubCat = values.subCat;
      const formattedSubCat = subCatData[rawSkill].find(s => s.value === rawSubCat)?.label || rawSubCat

      // Group results into fields
      const payload = {
        userId: user?._id,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        contactNumber: values.contactNumber,
        upi: values.upi,
        yearsOfExp: values.yearsOfExp,
        skill: formattedSkill,
        subCat: formattedSubCat,
        achievements: values.achievements,
        workLinks: values.WorkLinks,
        profilePicture: null,
        intro: null,
        performances: [],
        certifications: [],
        cameraMicAvailable: values.cameraMicAvailable,
        allowPromotion: values.allowPromotion,
        subscribeUpdates: values.subscribeUpdates,
        platform: "web"
      };

      uploadedResults.forEach(({ label, result }) => {
        if (label === "profilePicture") {
          payload.profilePicture = result;
        } else if (label === "intro") {
          payload.intro = result;
        } else if (label.startsWith("performance")) {
          payload.performances.push(result);
        } else if (label.startsWith("certification")) {
          payload.certifications.push(result);
        }
      });

      setUploadProgress(100);
      console.info("Final Payload:", payload);

      const response = await axios.post(`${path}/v2/newJudgeData`, payload);

      console.info("judge response ", response.data);

      toast.success("Profile Created successfully!");
      setJudgeProfile(response.data.judgeProfile);
      dispatch(setJudgeDataId(response.data.judgeProfile._id));

      if(ENV === "prod") {
        trackEvent(EventTypes.APPLY_AS_JUDGE_COMPLETE);
      }
      // Submit `payload` to backend here
    } catch (err) {
      console.error("Error uploading judge profile:", err);
      toast.error("There was an error while submitting the form. Please try again!");
    } finally {
      setLoading(null);
    }
  };

  const handleSignUp = async () => {
    try {
      const ua = navigator.userAgent.toLowerCase();
      console.info("ua", ua);
      const isInstagram = ua.includes("instagram");
      const isAndroid = ua.includes("android");

      if (isInstagram && isAndroid) {
        return redirectToDefaultBrowser();
      } else {
        setSignUpModalOpen(true);
      }
    } catch (error) {
      console.error("Error in user signUp", error);
    }
  };

  const redirectToDefaultBrowser = () => {
    const refId = localStorage.getItem("uniqueId");

    // Get full hash path (e.g. "#/contest/abc123")
    const hash = window.location.hash; // includes the route part after #
    const route = hash.split("?")[0] || "#/"; // just the path without query

    // Attach query parameters
    const query = `refId=${refId}&openSignUp=true`;

    // Build final redirect URL
    const redirectUrl = `${window.location.origin}/${route}?${query}`;

    const intentUrl =
      "intent://" +
      redirectUrl.replace(/^https?:\/\//, "") +
      "#Intent;scheme=https;package=com.android.chrome;end";

    window.location.href = intentUrl;
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '+918956742394';
    const message = encodeURIComponent('Hello, I would like to get in touch with your team.');
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  };

  const handleEmailClick = () => {
    const email = 'support@feedants.com';
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent('Hello Team,\n\nI need help with...');
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  const loadingText = () => {
    if(loading === "judgeSubmit") {
      return uploadProgress >= 100
        ? "Finalizing your submission..."
        : `Uploading... ${Math.round(uploadProgress)}%`
    } else if(loading === "loadingJudgeProfile") {
      return "Checking Judge Profile"
    } else {
      return "";
    }
  }

  const applicationStatus = () => {
    if(judgeProfile?.status === "pending") {
      return "⏳ PENDING";
    } else if(judgeProfile?.status === "approved") {
      return "✅ APPROVED";
    } else if(judgeProfile?.status === "rejected") {
      return "❌ REJECTED";
    } else {
      return "";
    }
  }

  return (
    <div className="w-full min-h-svh bg-slate-100 font-gilroy-regular flex flex-col">
      {/* Header */}
      <Header />

      {loading && (
        <div className=" flex items-center justify-center gap-2 fixed inset-0 z-50 bg-white/80 text-[#008080] text-lg font-semibold">
          <div className="size-5 border-2 border-[#008080] rounded-full border-t-white animate-spin" />
          {loadingText()}
        </div>
      )}

      {signUpModalOpen && (
        <SignUpModal
          setSignUpModalOpen={setSignUpModalOpen}
          type="applyAsJudge"
        />
      )}

      {judgeProfile ? (
        <div className="flex flex-col items-center justify-center flex-1 p-6 text-center">

          {/* Icon with background */}
          <div className="p-3 rounded-full bg-gradient-to-br from-[#008080] to-[#043333] mb-6">
            <HourglassTopIcon className="text-white" fontSize="large" />
          </div>

          {/* Title and Info Section */}
          <div className="mx-auto max-w-xl w-full px-4 flex flex-col items-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-1">Thank you.</h2>
            <h4 className="text-sm text-[#707C97] font-gilroy-medium" >Application ID - {judgeProfile.applicationId}</h4>

            {/* Progress line with dots */}
            <div className="my-6 w-full flex items-center ">
              <span className="w-3 h-3 bg-gray-300 rounded-full" />
              <div className="flex-grow h-0.5 bg-gray-300" />
              <span className="w-3 h-3 bg-gray-300 rounded-full" />
            </div>

            {/* Info message */}
            <p className="text-base md:text-lg text-gray-700 mb-2">
              Our team reviews your profile within 3 business days.
            </p>
            <p className="text-base md:text-lg text-gray-700 mb-2">
              If approved, you’ll begin minimum judging 4–5 contests/mo.
            </p>

            <div className="flex items-center mb-10">
              <p className="text-base font-medium text-gray-700">
                Application Status:&nbsp;
              </p>
              <span className="text-base font-semibold text-gray-700" >{applicationStatus()}</span>
            </div>
          </div>

          {/* Full-width CTA button */}
          <Link
            to="/all-competition"
            className="w-full max-w-sm px-6 py-3 bg-[#008080] text-white rounded-lg font-semibold text-lg shadow hover:bg-[#005f5f] transition"
          >
            Visit Contest
          </Link>
          <div className="w-full max-w-sm mt-4 py-2 flex flex-col gap-2">
            <h1 className="text-base text-[#043333] font-medium tracking-tight text-center">
                Download the Feedants App for Full Experience...
            </h1>
            <div className="flex flex-row gap-2 text-sm">
              <a
              href={playstoreIntentUrl}
              className="flex-1 px-4 py-3 border border-[#008080] rounded-xl text-[#008080] flex items-center justify-center"
            >
              <AndroidIcon className="text-[#008080] size-4 mr-2"/>
              Play Store
            </a>
            <a
                href={"https://apps.apple.com/in/app/feedants/id6477408585"}
              className="flex-1 px-4 py-3 border border-[#008080] rounded-xl text-[#008080] flex items-center justify-center"
            >
              <AppleIcon className="text-[#008080] size-4 mr-2"/>
              Apple Store
            </a>
            </div>
          </div>
        </div>
      ) : (
        // Main Content
        <div className="flex-1 flex flex-col justify-center w-full md:max-w-lg mx-auto gap-2">
          {/* Form Body */}
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleJudgeSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize>
            {({
              handleChange,
              handleSubmit,
              values,
              errors,
              touched,
              setFieldTouched,
              setFieldValue,
            }) => (
              <div className="rounded-lg flex flex-col justify-between md:bg-white md:mt-4">
                <div className="bg-white pt-4 px-4">
                  {/* Title */}
                  <h1 className="text-xl font-medium tracking-tighter text-center">
                    Apply As Judge
                  </h1>

                  {/* Steps */}
                  <div className="relative flex flex-row justify-between my-2">
                    <StepsIcon
                      id={0}
                      text="Basic Info"
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      filledStatus={filledStatus}
                    />
                    <StepsIcon
                      id={1}
                      text="Skill & Experience"
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      filledStatus={filledStatus}
                    />
                    <StepsIcon
                      id={2}
                      text="Achievements"
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      filledStatus={filledStatus}
                    />
                    <StepsIcon
                      id={3}
                      text="Media Showcase"
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      filledStatus={filledStatus}
                    />

                    {/* Progress Bar */}
                    <div className="absolute h-[2px] inset-x-6 top-[10px] rounded-full bg-[#9C9C9D]">
                      <div
                        className="h-full bg-[#008080] transition-all duration-300 ease-in-out"
                        style={{ width: `${(currentStep / 3) * 100}%` }}></div>
                    </div>
                  </div>
                </div>
                <div className="flex-1 px-4 flex-col flex justify-between">
                  <>
                    {currentStep === 0 && (
                      <BasicDetails
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        touched={touched}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        isEnglish={isEnglish}
                        setIsEnglish={setIsEnglish}
                      />
                    )}
                    {currentStep === 1 && (
                      <SkillDetails
                        handleChange={handleChange}
                        values={values}
                        errors={errors}
                        touched={touched}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        isEnglish={isEnglish}
                      />
                    )}
                    {currentStep === 2 && (
                      <Achievements
                        achievements={values.achievements}
                        handleChange={handleChange}
                        WorkLinks={values.WorkLinks}
                        setFieldValue={setFieldValue}
                        Certifications={values.Certifications}
                        errors={errors}
                        isEnglish={isEnglish}
                      />
                    )}
                    {currentStep === 3 && (
                      <MediaShowcase
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                        isEnglish={isEnglish}
                      />
                    )}
                  </>
                  {/* Next/Submit Button */}
                  <div className="bottom-0 w-full flex flex-col items-center justify-center py-2 mt-6">
                      {currentStep === 3 && 
                      <div className="px-3 py-1 rounded-lg border border-amber-600 bg-amber-100 text-xs text-amber-600 mb-2">
                        <p>
                          {isEnglish
                            ? "Note: Please ensure you have a stable internet connection before submitting."
                            : "नोट: कृपया सबमिट करने से पहले सुनिश्चित करें कि आपके पास स्थिर इंटरनेट कनेक्शन है।"}
                        </p>
                      </div>}
                      <button
                        className="p-3 bg-[#008080] rounded-xl w-full text-base text-white  transition-transform duration-150 active:scale-95"
                        onClick={() => {
                          user?._id ? handleSubmit() : handleSignUp();
                        }}>
                        {currentStep !== 3 ? "Next": "Submit"}
                      </button>
                      <div className=" items-center flex gap-2.5 justify-center mt-2 text-[10px]">
                          <p className="text-gray-500 tracking-tight ">Need help?</p>
                          <div
                          className="font-semibold flex items-center gap-0.5"
                          onClick={()=>handleWhatsAppClick()}
                          >
                            <WhatsAppIcon className="text-[#6EBF61]" fontSize="small" />   
                            Whatsapp
                          </div>
                          <div className="h-[6px] w-[6px] bg-gray-200 rounded-full"/>
                          <p className="text-gray-400 items-center gap-1 flex"
                          onClick={()=>handleEmailClick()}
                          >
                            <EmailIcon className="text-gray-500 h-1 w-1" fontSize="small" />
                            support@feedants.com
                          </p>
                      </div>
                  </div>
              </div>
              </div>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
}

export default ApplyAsJudge;
